import type { CompanyHead } from '~/domains/companies/types'
import type { ContactHeadData } from '~/domains/contacts/types'
import type { OrderHead } from '~/domains/orders/types'
import type { TaxonomyItem, VatRate } from '~/domains/taxonomies/types'

export enum InvoiceStatus {
  DRAFT = 'draft',
  VALIDATED = 'validated',
  PARTIALLY_PAID = 'partially_paid',
  FULLY_PAID = 'fully_paid'
}
export const InvoiceStatusLabels: Record<InvoiceStatus, string> = {
  [InvoiceStatus.DRAFT]: 'Brouillon',
  [InvoiceStatus.VALIDATED]: 'Non payée',
  [InvoiceStatus.PARTIALLY_PAID]: 'Partiellement payée',
  [InvoiceStatus.FULLY_PAID]: 'Payée'
}

export type InvoiceLine = {
  id?: number
  description: string
  quantity: number
  unitPriceHT: string
  vatRate: VatRate
  position?: number
}

export type InvoiceLineData = {
  description: string
  quantity: number
  unitPriceHT: number
  vatRateId: string
}

export type InvoiceLineDto = {
  description: string
  quantity: number
  unitPriceHT: string
  vatRate: string
}

export type InvoiceType = TaxonomyItem<'invoice_types'>

export type Invoice = {
  id: number
  label: string
  status: InvoiceStatus
  issuedAt: string | null
  createdAt: string
  dueDate: string | null
  order: OrderHead
  contact: (ContactHeadData & { company: CompanyHead }) | null
  type: TaxonomyItem<'invoice_types'>
  lines: InvoiceLine[]
  totalAmountHT: number
  totalAmountTTC: number
  paidAmount: number
  remainingAmount: number
  paymentMethod: string | null
  paymentDate: string | null
  externalRef: string | null
  comments: string | null
}

export type InvoiceDto = Omit<
  Invoice,
  | 'id'
  | 'totalAmountHT'
  | 'totalAmountTTC'
  | 'remainingAmount'
  | 'paidAmount'
  | 'order'
  | 'type'
  | 'contact'
  | 'lines'
  | 'createdAt'
> & {
  order: string
  contact: string | null
  type: string
  lines: InvoiceLineDto[]
  paidAmount?: string
}

export type UpdateInvoiceDto = Partial<InvoiceDto>

export type InvoiceListFilters = {
  companyId?: number
  orderId?: number
  status?: string
  dateFrom?: string
  dateTo?: string
  sort?: string
  sortDirection?: string
  label?: string
  externalRef?: string
  id?: number
  userIds?: string
  dueDateFrom?: string
  dueDateTo?: string
  paymentDateFrom?: string
  paymentDateTo?: string
}
